import { Outlet, Navigate } from "react-router-dom";
import { useEffect } from "react";

const isAuthenticated = () => {
  const token = localStorage.getItem("authToken");
  // console.log("Auth check - Token exists:", token !== null);
  return token !== null;
};

const ProtectedRoutes = () => {
  useEffect(() => {
    // console.log("ProtectedRoutes mounted - Auth status:", isAuthenticated());
  }, []);

  const authenticated = isAuthenticated();

  if (!authenticated) {
    // console.log("Not authenticated, redirecting to login");
    return <Navigate to="/login" />;
  }

  // console.log("User is authenticated, rendering protected content");
  return <Outlet />;
};

export default ProtectedRoutes;
